// Longitude bookkeeping between MapLibre and the server's bounding-box contract.
//
// MapLibre reports a viewport UNWRAPPED — pan east past Fiji and getEast()
// reads 190 — while Prospecting::Sources::BoundingBox.normalise accepts only
// longitudes in [-180, 180] and spells a box across the antimeridian as
// west > east. Anything outside that range is DROPPED server-side, so a raw
// edge posted from the map threw the rep's viewport away in silence.

// A longitude wrapped into [-180, 180]. One already in range comes back
// exactly as it was — the modulo below would otherwise nudge it by a rounding
// error on every pan. An eastward edge landing exactly on the antimeridian
// stays +180 rather than flipping to -180, so an east edge of 180 still reads
// as the east edge of the world.
export function wrapLongitude(lng) {
  if (lng >= -180 && lng <= 180) return lng
  const wrapped = ((((lng + 180) % 360) + 360) % 360) - 180
  return wrapped === -180 && lng > 0 ? 180 : wrapped
}

// A MapLibre viewport {south, west, north, east} in the server's shape. A
// span of 360° or more is the whole world, written as its two real edges:
// wrapping those edges one at a time would turn "everything" into a narrow or
// inverted strip the rep is not looking at.
export function normaliseViewport({ south, west, north, east }) {
  if (east - west >= 360) return { south, west: -180, north, east: 180 }
  return { south, west: wrapLongitude(west), north, east: wrapLongitude(east) }
}

// The way back in: a box from the server (the restored viewport, a picked
// place) may cross the antimeridian as west > east, and MapLibre centres and
// fits only an unwrapped box (west < east, east past 180). Null stays null.
export function unwrapBox(box) {
  if (!box) return null
  return box.west > box.east ? { ...box, east: box.east + 360 } : box
}
